import React from 'react';
import Scrapbook from './components/Scrapbook';

function App() {
  return <Scrapbook />;
}

export default App;
